import I18n from 'app/i18n';

const WithoutZeroDays = ({diffDays}) => Number(diffDays)
    ? I18n.t('days', {count: diffDays})
    : null;

export default WithoutZeroDays;
